import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import ReactTimeAgo from 'react-time-ago';
import BinkiesIcon from '../../assets/images/Binkies-icon.svg';
import ComplimentIcon from '../../assets/images/Compliment-icon.svg';
import { insightsViewModel } from '../views/dashboard/insights.view.model';
import { getCommentUserProfileUrl, getUserProfileUrl } from '../../utils/camp.utils';
import { MOST_BINKIED, MOST_COMMENTED, SHARE_CREATION_ROUTE_BANNER } from '../../constants/routes.constants';
import { useHistory } from 'react-router-dom';
import "./binkiesCompliments.css";
import { getUserTypeBadge } from '../../utils/utils';
import { Image } from 'react-bootstrap';
import IIcon from '../../assets/icon/PRINT.svg';
import NoMostComplimentImg from '../../assets/images/tour/no-most-complimented.svg';
import NoMostBinkyImg from '../../assets/images/tour/no-most-binky.svg';
import CampNoDataTooltip from '../views/school/camp_tour/CampNoDataTooltip';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none',
  },
  commentsSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  mediaSection: {
    width: '100%',
    marginTop: theme.spacing(2),
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: 8,
    boxShadow: 'none',
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  content: {
    flex: '1 0 auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    padding: '0px 7px',
  },
  message: {
    display: 'inline-block',
    padding: theme.spacing(0.5, 1),
    borderRadius: 4,
  },
  media: {
    width: '100%',
    borderRadius: 8,
    height: '230px',
    objectFit: 'contain',
  },
  icon: {
    marginRight: '21px',
    paddingLeft: '15px',
  },
  complimentText: {
    padding: '8px',
    borderRadius: '4px',
    marginLeft: '20px',
  },
}));

const commentColors = [
  '#ffd29f',
  '#C0FECF',
  '#F2F6AB',
  '#D6D5FD',
  '#B3E5FE',
  '#9CF2F1',
  '#FDE988',
  '#ffd6fa',
  '#d6fbff',
  '#ddd6ff',
];

const MostCommentedCreation = ({ type, dependent, cardClass }) => {
  const _PAGE_LIMIT = 3;
  const history = useHistory();
  const classes = useStyles();
  const [compliments, setCompliments] = useState([]);
  const [showNoDataTooltip, setShowNoDataTooltip] = useState(false);
  const [tooltipData, setTooltipData] = useState([]);

  const NoMostCompliment = [
    {
      element: '#no-most-Comment',
      intro: `
      <div class="custom-tour-step">
        <img src="${NoMostComplimentImg}" alt="Camp Master" class="tour-avatar" />
        <h3>Most Complimented Creation</h3>
        <p>The 'Most Complimented Creation' highlights the creation that has received the highest number of compliments from other child. This feature helps showcase the most admired work, allowing creators to gain recognition for their efforts. Encourage your child to share their creations, and theirs could be the next to receive the most compliments!</p>
      </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];

  const NoMostBinky = [
    {
      element: '#no-most-Binky',
      intro: `
      <div class="custom-tour-step">
        <img src="${NoMostBinkyImg}" alt="Camp Master" class="tour-avatar" />
        <h3>Most Liked Creation</h3>
        <p>'Most Liked Creation' showcases the piece that has received the highest number of binkies from the community. This feature highlights the work that resonates most with other kids, providing recognition to creators for their talent and effort.</p>
      </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];

  const getComplimentsReceived = () => {
    const API =
      type === 'Comment'
        ? insightsViewModel.dependentMostCommentedCreation
        : insightsViewModel.dependentMostBinkiedCreation;
    const list = [];
    let query = {
      limit: _PAGE_LIMIT,
      has_more: true,
      dependent_id: dependent.id,
    };
    API(query, list)
      .then((res) => {
        setCompliments(
          res.commentList.map((item, i) => {
            const colorIndex = i % 10;
            item.colorIndex = colorIndex;
            return item;
          })
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    setCompliments([]);
    getComplimentsReceived();
  }, [dependent]);

  const returnDependentProfile = (user) => {
    const kid = {
      profile: {
        picture_url: user?.picture_url,
        taletree_friend: user?.taletree_friend,
      },
    };
    return kid;
  };

  const handleSeeAllClick = () => {
    history.push({
      pathname: type === 'Comment' ? MOST_COMMENTED : MOST_BINKIED,
      state: {
        dependent: JSON.stringify(dependent),
        type: type,
      },
    });
  };

  const onRedirect = (user) => {
    if (user.user_type === 'dependent') history.push(`/${user.username}`);
  };

  const onArtClick = (creationId) => {
    const encoded = btoa(`{"id":${creationId}, "slug":"creation"}`);
    history.push({
      pathname: SHARE_CREATION_ROUTE_BANNER,
      search: `?encrypt=${encoded}`,
    });
  };

  const handleNoDataClick = () => {
    if (type === 'Comment') {
      setTooltipData(NoMostCompliment);
    } else {
      setTooltipData(NoMostBinky);
    }
    setShowNoDataTooltip(true);
  };

  return (
    <Box className={`${classes.root} ${cardClass}`}>
      <CampNoDataTooltip
        showTooltip={showNoDataTooltip}
        setShowTooltip={setShowNoDataTooltip}
        step={tooltipData}
      />
      <Box className={classes.header}>
        <Typography variant="h6" className="compliments-received">
          <img
            src={type === 'Comment' ? ComplimentIcon : BinkiesIcon}
            alt="Comment Icon"
            className={classes.icon}
          />
          {`${dependent?.username}'s most ${
            type === 'Comment'
              ? `Complimented creation (${
                  compliments[0]?.creation?.comment_count
                    ? compliments[0]?.creation?.comment_count
                    : 0
                } Positive Comments)`
              : `liked creation (${
                  compliments[0]?.creation?.binky_count
                    ? compliments[0]?.creation?.binky_count
                    : 0
                } Binkies)`
          }`}
        </Typography>
        {compliments.length > 0 && (
          <Typography
            variant="body2"
            onClick={handleSeeAllClick}
            style={{ cursor: 'pointer', marginRight: '10px' }}
            color="primary"
            className="insights-see-all-text"
          >
            See All
          </Typography>
        )}
      </Box>
      <Divider />
      <Box className={classes.root}>
        {compliments.length > 0 ? (
          <div
            className="compliment-div"
            style={{ flexDirection: 'row', display: 'flex' }}
          >
            <Box className={classes.commentsSection}>
              {compliments.map((compliment, index) => (
                <div key={index}>
                  {/* {index > 0 && <Divider />} */}
                  <Card className={classes.card}>
                    <Avatar
                      src={
                        compliment?.user?.picture_url
                          ? compliment.user.picture_url
                          : compliment?.user?.user_type === 'dependent'
                          ? getUserProfileUrl(
                              returnDependentProfile(compliment?.user)
                            )
                          : getCommentUserProfileUrl(compliment?.user)
                      }
                      className={classes.avatar}
                    />
                    <CardContent className={classes.content}>
                      <Typography variant="body2" color="textSecondary">
                        From:{' '}
                        <Link onClick={() => onRedirect(compliment?.user)}>
                          {compliment?.user?.user_type === 'dependent'
                            ? compliment?.user?.username
                            : `${compliment?.user?.first_name} ${compliment?.user?.last_name}`}
                        </Link>
                        {type === 'Comment' && (
                          <span
                            className={classes.complimentText}
                            style={{
                              backgroundColor:
                                commentColors[compliment.colorIndex],
                            }}
                          >
                            {compliment.text}
                          </span>
                        )}
                      </Typography>
                      <Typography
                        variant="p"
                        component={'p'}
                        color="textSecondary"
                      >
                        {compliment?.user?.user_type === 'school_teacher' ||
                        compliment?.user?.user_type === 'school' ||
                        compliment?.user?.user_type === 'camp master' ||
                        compliment?.user?.user_type === 'partner' ? (
                          <button className="blue-admin-button">
                            {getUserTypeBadge(compliment?.user?.user_type)}
                          </button>
                        ) : (
                          ''
                        )}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        <ReactTimeAgo date={compliment?.created_at} />
                      </Typography>
                    </CardContent>
                  </Card>
                </div>
              ))}
            </Box>
            <Box
              className={classes.mediaSection}
              onClick={() => onArtClick(compliments[0]?.creation?.id)}
            >
              <img
                src={compliments[0]?.creation?.media[0]?.url}
                alt="Creation"
                className={classes.media}
              />
            </Box>
          </div>
        ) : (
          <div className="insights-text no-data-found" id={`no-most-${type}`}>
            <div className="text-wrapper">
              <Image
                src={IIcon}
                alt="no-data"
                className="add-pointer"
                onClick={handleNoDataClick}
              />
              <Typography variant="body1">
                There isn't a most {type === 'Binky' ? 'liked' : 'commented'}{' '}
                creation yet, but that's okay, it will come with time.
              </Typography>
            </div>
          </div>
        )}
      </Box>
    </Box>
  );
};

export default MostCommentedCreation;
